import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import MarkdownToHtml from '../../../MarkdownToHtml';
import AboutDetails from '../../../TravelOption/HotelInformation/HotelDetails/AboutDetails';
import AmenitiesDetails from '../../../TravelOption/HotelInformation/HotelDetails/AmenitiesDetails';
import HotelDeals from '../../../TravelOption/HotelInformation/HotelDetails/HotelDeals';
import { checkDoShowAgentCommission } from '../../../../store/slices/user';

const HotelDetailsContent = ({ hotelDetails }) => {
  const { travelAgency } = useSelector((store) => store.user);
  const doShowAgentCommission = useSelector(checkDoShowAgentCommission);
  const customHotelTabContent =
    hotelDetails && hotelDetails.hotel && hotelDetails.hotel.customContents;
  const hotelTabTitle =
    travelAgency && travelAgency.filterSettings && travelAgency.filterSettings.hotelDealsTabTitle;

  const aboutTab =
    customHotelTabContent && customHotelTabContent.find((tab) => tab.tabName === 'About');
  const doHideAboutTab = aboutTab && aboutTab.doHideTab;

  const amenitiesTab =
    customHotelTabContent && customHotelTabContent.find((tab) => tab.tabName === 'Amenities');
  const doHideAmenitiesTab = amenitiesTab && amenitiesTab.doHideTab;

  const aboutContent =
    aboutTab && aboutTab.tabContent ? (
      <MarkdownToHtml content={aboutTab.tabContent} className="text-black" />
    ) : (
      hotelDetails &&
      hotelDetails.hotel && (
        <AboutDetails
          hotelDetails={hotelDetails.hotel}
          doShowAgentCommission={doShowAgentCommission}
          headerClassName="font-normal text-xl"
        />
      )
    );

  let amenities = [];
  if (!doHideAmenitiesTab) {
    amenities = hotelDetails && hotelDetails.hotel ? hotelDetails.hotel.amenities : [];
    if (amenitiesTab && amenitiesTab.tabContent) {
      const customAmenties = amenitiesTab.tabContent.split(/\s*,\s*/).filter((item) => item !== '');
      if (customAmenties && customAmenties.length) {
        amenities = customAmenties;
      }
    }
  }

  return (
    <>
      {!doHideAboutTab ? aboutContent : <></>}
      {!doHideAmenitiesTab && amenities && amenities.length > 0 ? (
        <AmenitiesDetails hotelAmenities={amenities} headingClassName="font-normal text-xl" />
      ) : (
        <></>
      )}
      {customHotelTabContent &&
        customHotelTabContent.length &&
        customHotelTabContent.map((tab) =>
          tab && !tab.doHideTab && tab.tabContent && tab.tabName === 'Custom' ? (
            <div key={tab.displayTabName ? tab.displayTabName : tab.tabName}>
              <h3 className="font-normal text-xl">
                {tab.displayTabName ? tab.displayTabName : tab.tabName}
              </h3>
              <MarkdownToHtml content={tab.tabContent} className="text-black" />
            </div>
          ) : (
            <></>
          ),
        )}
      {hotelDetails && hotelDetails.hotelDeals && hotelDetails.hotelDeals.length > 0 && (
        <div>
          <h3 className="font-normal text-xl">{hotelTabTitle || 'Deals'}</h3>
          <HotelDeals deals={hotelDetails && hotelDetails.hotelDeals} />
        </div>
      )}
    </>
  );
};

HotelDetailsContent.propTypes = {
  hotelDetails: PropTypes.shape().isRequired,
};

export default HotelDetailsContent;
